module.exports = __webpack_public_path__ + "static/media/instructions_second.24c4d57f.mp3";